module.exports = __webpack_public_path__ + "img/costa-rica.594f9874.svg";